import qs from 'qs';
import {
  put, all, call, takeLatest,
} from 'redux-saga/effects';
import { NetworkService } from 'services';
import { changeLoadingState, setErrorMessage } from 'app/settings/slices';
import { saveUserActions, saveUserRecentActions } from 'actions/userActions/userActionsActionCreator';
import UserActionsActionType from 'actions/userActions/userActionsActionType';
import { AppConstants } from 'constants/index';
import { getError } from 'utils/helpers';
import { isJSON } from 'utils/utils';

function* getUserActions({ payload }) {
  try {
    const {
      ReportingAdmin, AuditLog, User, Actions,
    } = AppConstants.api;
    const options = {
      params: payload.params,
      paramsSerializer: (params) => qs.stringify(params),
    };
    yield put(changeLoadingState(true));
    const { data } = yield call(NetworkService.makeAPIGetRequest, [ReportingAdmin, AuditLog, User, Actions], options);
    yield put(saveUserActions(data));
    yield put(changeLoadingState(false));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

function* getUserRecentActions({ payload }) {
  try {
    const {
      ReportingAdmin, AuditLog, User, Actions,
    } = AppConstants.api;
    const options = {
      params: payload.params,
      paramsSerializer: (params) => qs.stringify(params),
    };
    yield put(changeLoadingState(true));
    const { data } = yield call(NetworkService.makeAPIGetRequest, [ReportingAdmin, AuditLog, User, Actions], options);
    yield put(saveUserRecentActions(data));
    yield put(changeLoadingState(false));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

export default function* reportingSaga() {
  yield all([takeLatest(UserActionsActionType.GET_USER_ACTIONS, getUserActions), takeLatest(UserActionsActionType.GET_USER_RECENT_ACTIONS, getUserRecentActions)]);
}
